<template>
  <div class="float-navbar">
    <p class="float-navbar__title">浮动导航栏</p>
    <p class="float-navbar__subtitle">
      顶部透明导航栏，当页面滚动时悬浮并变不透明，此模块无须预览，提供占位即可。
    </p>
  </div>
</template>

<script>
export default {
  name: 'FloatNavbarPreview'
}
</script>

<style lang="scss" scoped>
.float-navbar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  margin: 0 auto;
  background-color: #fff;
  overflow: hidden;
  &__title {
    font-size: 24px;
  }
  &__subtitle {
    font-size: 16px;
    color: #999999;
    margin-top: 10px;
  }
}
</style>
